import { IntlProvider } from 'react-intl';
import React from 'react';

const CustomIntlProviderComponent = ({ children, locale, messages }) => (
  <IntlProvider key={locale} locale={locale} messages={messages}>
    {children}
  </IntlProvider>
);

CustomIntlProviderComponent.displayName = 'CustomIntlProviderComponent';
export default CustomIntlProviderComponent;



// WEBPACK FOOTER //
// ./src/Shared/CustomIntlProvider/CustomIntlProvider.js